export default __webpack_public_path__ + "static/media/American Home Life.f1ddc4e6.svg";